// Cadastro de Categoria (issue #3, revisto no ADR-0006). Uma Categoria só
// classifica o Tipo de Peça — para agrupar na Tabela de Preços, nos filtros e na
// exportação. Não define rota. Funções puras sobre o Snapshot.

import { newId, type Id } from "./ids.ts";
import type { Categoria, Snapshot } from "./snapshot.ts";

export type { Categoria };

export interface DadosCategoria {
  nome: string;
}

export class ErroCategoria extends Error {}

function validar(
  dados: DadosCategoria,
  snapshot: Snapshot,
  ignorarId?: Id,
): { nome: string } {
  const nome = dados.nome.trim();
  if (nome === "") throw new ErroCategoria("Informe o nome da categoria.");

  const duplicada = snapshot.categorias.some(
    (c) => c.id !== ignorarId && c.nome.toLowerCase() === nome.toLowerCase(),
  );
  if (duplicada) throw new ErroCategoria(`Já existe a categoria "${nome}".`);

  return { nome };
}

export function criarCategoria(
  snapshot: Snapshot,
  dados: DadosCategoria,
): Snapshot {
  const { nome } = validar(dados, snapshot);
  const categoria: Categoria = { id: newId(), nome, ativo: true };
  return { ...snapshot, categorias: [...snapshot.categorias, categoria] };
}

export function editarCategoria(
  snapshot: Snapshot,
  id: Id,
  dados: DadosCategoria,
): Snapshot {
  if (!snapshot.categorias.some((c) => c.id === id)) {
    throw new ErroCategoria("Categoria não encontrada.");
  }
  const { nome } = validar(dados, snapshot, id);
  return {
    ...snapshot,
    categorias: snapshot.categorias.map((c) =>
      c.id === id ? { ...c, nome } : c,
    ),
  };
}

export function definirAtivoCategoria(
  snapshot: Snapshot,
  id: Id,
  ativo: boolean,
): Snapshot {
  if (!snapshot.categorias.some((c) => c.id === id)) {
    throw new ErroCategoria("Categoria não encontrada.");
  }
  return {
    ...snapshot,
    categorias: snapshot.categorias.map((c) =>
      c.id === id ? { ...c, ativo } : c,
    ),
  };
}

/** Categorias-semente de um banco novo. */
export function defaultCategorias(): Categoria[] {
  return [
    { id: newId(), nome: "Banho", ativo: true },
    { id: newId(), nome: "Mesa", ativo: true },
    { id: newId(), nome: "Cama", ativo: true },
  ];
}
